import React from 'react'
import BaseAccordion from '../molecules/BaseAccordion'
import RevealOnScroll from '../atoms/RevealOnScroll'
import styles from './FaqSection.module.css'

const faqs = [
    {
        question: 'Annual Percentage Rate (APR)',
        answer: `Here at Trustedonlineloans we offer APR rates ranging from 4.95% minimum to 35.95% maximum. </br> The APR you may be offered depends on different factors, including your personal situation and financial standing. By completing our loan offer form you shall receive details of the APR and full terms of any loan offered to you. </br> The actual interest rate you may be offered depends on several factors: your credit score, financial history, income, etc. Contact your lender for more information about the APR you may receive and the terms of your loan agreement.`
    },
    {
        question: 'Loan Term (Repayment Period)',
        answer: `<table><tbody><tr><td>Minimum</td><td>Maximum</td></tr><tr><td>90 days</td><td>84 months</td></tr></tbody></table>`
    },
    {
        question: 'Representative Example of APR',
        answer: `If you borrow $2,500 over a term of 1 year with an APR of 10% and a fee of 3%, you will pay $219.79 each month. The total amount payable will be $2,637, with a total interest of $137.48.`
    },
    {
        question: 'Financial Implications (Interest & Finance Charges)',
        answer: `Trustedonlineloans is not a lender and we cannot predict what fees and interest rate will be applied to the loan you will be offered. It is your lender that will provide all the necessary information about the cost of the loan. It is your responsibility to peruse the loan agreement carefully and accept the offer only if you agree to all the terms. Trustedonlineloans service is free of charge, and you are under no obligation to accept the terms that the lender offers you.`
    },
    {
        question: 'Implications of Non-Payment',
        answer: `When you accept the terms and conditions for a loan, you enter into a commitment to repay the amount you owe according to the specific schedule outlined in the documents. In the event of non-payment, additional charges may be applied. Late payment penalties vary by lender, and as Trustedonlineloans is not involved in the lending process, we cannot supply any information on the fees you will incur if any default occurs. For more information, please contact the lender directly if you have any issues relating to your loan repayment.`
    },
    {
        question: 'Potential Impact on Credit Score',
        answer: `Trustedonlineloans is not a lender and we do not check your credit standing and credit capacity. </br> When you submit a request at our online platform, this is considered a soft inquiry and does not impact your credit score. However, some lenders may carry out a credit check to ascertain your eligibility for a loan. Most likely they will turn to any of the three major credit bureaus (Transunion, Experian, and Equifax) that is in most cases considered a hard inquiry and may affect your credit score.`
    },
    {
        question: 'Collection Practices',
        answer: `Trustedonlineloans is not a lender. As such, we are not involved in any debt collection practices and cannot make you aware of any of them. Your lender will specify their collection practices in your loan agreement. If you have any questions regarding the issue, please, address them to your lender. For more information visit our page for Responsible Lending. Trustedonlineloans.com itself isn’t involved in debt collection.`
    },
    {
        question: 'Loan Renewal Policies',
        answer: `Loan renewal options are not always available. It is therefore advisable to clarify whether the option is available with your lender. Be sure to carefully peruse the renewal policy presented in the agreement before you sign the documents.`
    },
];

export const FaqSection = () => {
    return (
        <section className={styles.faqSection}>
            <div className={styles.contentContainer}>
                <RevealOnScroll className={styles.headerBlock} animation="fade-in" threshold={0.2}>
                    <p className={styles.subHeading}>We are here to answer your questions</p>
                    <h2 className={styles.mainHeading}>Frequently Asked Questions</h2>
                    <p className={styles.introText}>
                        When applying for a loan, you may have questions about the process or requirements. To make it easier, we've compiled answers to the most frequently asked questions
                    </p>
                </RevealOnScroll>

                <RevealOnScroll className={styles.accordionWrapper} animation="reveal-up" threshold={0.1}>
                    <BaseAccordion items={faqs} />
                </RevealOnScroll>
            </div>
        </section>
    )
}

export default FaqSection
